import { Spinner } from "@public/ui-toolkit";
import React, { useRef, useEffect, useState } from "react";
import { SendMessageForm } from "@hedgefund/shared";
import { Row, Col } from "antd/es/grid";
const RoomType = [
  {
    id: 0,
    name: "Private"
  },
  {
    id: 1,
    name: "Group"
  }
]
const ChatMessenger = ({
  messageResult,
  sendMessage,
  uploadFiles,
  selectedRoom,
  loading,
  userId,
  conversationSectionRef,
  isChatToggle,
  isHedgeFund,
  UpdateMessageSeen
}) => {
  useEffect(() => {
    if (conversationSectionRef && conversationSectionRef.current) {
      UpdateMessageSeen();
      const { scrollHeight, clientHeight } = conversationSectionRef.current;
      conversationSectionRef.current.scrollTo({
        left: 0,
        top: scrollHeight - clientHeight,
        behavior: "smooth",
      });
    }
  }, [messageResult, messageResult?.length]);

  return (
    <Row className="main-chat-box">
      {(() => {
        if (selectedRoom) {
          return (
            <Col span={24}>
              {(() => {
                if (selectedRoom.type == RoomType[0].id) {
                  return (
                    <Col span={24} className="main-chat-box-header">
                      <Col span={1} className="contact-avatar">
                        <img src={selectedRoom?.coverImage ? selectedRoom?.coverImage : "./assets/images/avatar.png"} style={{ position: "relative", top: "0", left: "0", borderRadius: "50%", height: "55px", width: "55px" }} alt="avatar" />
                        <img src={selectedRoom?.profileImage ? selectedRoom?.profileImage : "./assets/images/avatar.png"} style={{ position: "absolute", top: "5px", left: "10px", borderRadius: "50%", height: "55px", width: "55px" }} alt="avatar" />
                      </Col>
                      <Col span={21} className="contact-info">
                        <Col className="user-name text-mini" style={{ fontWeight: "bold", color: "#276598" }}>{selectedRoom?.userName} </Col>
                        <Col className="user-name text-mini" style={{ color: "#3ac1b5" }}>{selectedRoom?.tenantName} </Col>
                        <Col className="user-status">Online</Col>
                      </Col>
                      <Col span={1}></Col>
                      {/* {(() => {
                        if (isHedgeFund) {
                          return (<Col  span={1} ></Col>);
                        } else {
                          return (
                            <Col span={1} className="inner2">
                              <Col className="profile-dropdown">
                                <button
                                  type="button"
                                  className="dropdown-toggle moreOption"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i
                                    className="fa fa-ellipsis-v"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu">
                                  <li>
                                    <a
                                      href
                                      className="dropdown-item"
                                      // onClick={() => updateArchive(false, u)}
                                      type="button"
                                    >
                                      <span className="text">Move to Inbox</span>
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Col>
                          )
                        }
                      })()} */}
                    </Col>
                  )
                }
                else {
                  return (
                    <Col span={24} className="main-chat-box-header">
                      <Col span={1} className="contact-avatar">
                        <img src={selectedRoom?.coverImage ? selectedRoom?.coverImage : "./assets/images/avatar.png"} style={{ position: "relative", top: "0", left: "0", borderRadius: "50%", height: "55px", width: "55px" }} alt="avatar" />
                      </Col>
                      <Col span={21} className="contact-info">
                        <Col className="user-name text-mini" style={{ fontWeight: "bold", color: "#3ac1b5" }}>{selectedRoom?.tenantName} </Col>
                        <Col className="user-status">Online</Col>
                      </Col>
                      <Col span={1}></Col>
                      {/* {(() => {
                        if (isHedgeFund) {
                          return (<Col  span={1} ></Col>);
                        } else {
                          return (
                            <Col span={1} className="inner2">
                              <Col className="profile-dropdown">
                                <button
                                  type="button"
                                  className="dropdown-toggle moreOption"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i
                                    className="fa fa-ellipsis-v"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu">
                                  <li>
                                    <a
                                      href
                                      className="dropdown-item"
                                      // onClick={() => updateArchive(false, u)}
                                      type="button"
                                    >
                                      <span className="text">Move to Inbox</span>
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Col>
                          )
                        }
                      })()} */}
                    </Col>
                  )
                }
              })()}
              <Row gutter={[12,12]}>
              <Col span={24} className="main-chat-box-body">
                <div ref={conversationSectionRef} className="users-conversation">
                  {!messageResult?.length && !loading ? (
                    <img
                      src="./assets/images/no-messages.svg"
                      className="no-message"
                      alt="no messages"
                    />
                  ) : !loading ? (
                    messageResult?.map((m, index) => {
                      return (
                        <div key={index} className="single-message-box ">
                          <div
                            className={`single-message-box-inner  ${userId === m.userId ? "right" : "left"
                              }`}
                          >
                            <div className="avatar">
                              <img
                                src={
                                  m.profileImage
                                    ? m.profileImage
                                    : "./assets/images/user.png"
                                }
                                alt="avatar"
                              />
                            </div>
                            <div
                              className="single-message"
                              style={{ fontWeight: "500" }}
                            >
                              {<p dangerouslySetInnerHTML={{ __html: m.body }} />}
                              <p
                                className="mb-0"
                                style={{ fontSize: "12px", fontWeight: "300" }}
                              >
                                {m.userName}
                              </p>
                            </div>
                          </div>
                          <div className={`chat-media-box`}>
                            {m?.recordFiles?.map((record, i) => {
                              return (
                                <div
                                  data-bs-toggle={"modal"}
                                  data-bs-target={`#video-pop${index + i}`}
                                  key={record.documentUrl}
                                  style={{ float: userId === m.userId ? "right" : "" }}
                                >
                                  <div className="media-thumbnail-box chat-thumbnail-box">
                                    {record.type?.toLowerCase() === "video" ||
                                      record.type === null ? (
                                      <video
                                        src={`${record.documentUrl}#t=4`}
                                        className="media-thumbnail"
                                        alt="media thumbnail"
                                      />
                                    ) : (
                                      <img
                                        src={record.documentUrl}
                                        className="media-thumbnail"
                                        alt="media thumbnail"
                                      />
                                    )}
                                    {(record.type?.toLowerCase() === "video" ||
                                      record.type === null) && (
                                        <img
                                          src="./assets/images/video-icon.svg"
                                          className="media-icon"
                                          alt="play icon"
                                        />
                                      )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <Spinner />
                  )}
                </div>
                <Col span={24} className="message-box p-4">
                  <SendMessageForm
                    sendMessage={(sendMessage)}
                    uploadFiles={uploadFiles}
                    isChatToggle={isChatToggle}
                  />
                </Col>
              </Col>
              </Row>
            </Col>
          )
        }
        else {
          return (
            <Col span={24} className="main-chat-box-body">
              <Col className="users-conversation">
                <img
                  src="./assets/images/no-messages.svg"
                  className="no-message"
                  alt="no messages"
                />
              </Col>
            </Col>
          )
        }

      })()}
    </Row>
  );
};

export default ChatMessenger;
